import React from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { ClipboardIcon, SearchIcon, RocketIcon } from 'lucide-react';
export const AIProcess = () => {
  const steps = [{
    title: 'Choose a plan',
    description: 'Pick a subscription that matches your AI ambition and budget.',
    icon: <ClipboardIcon className="w-12 h-12 text-primary group-hover:text-primary-light transition-transform duration-300" data-id="element-265" />,
    number: 1
  }, {
    title: 'AI audit & roadmap',
    description: 'Your fractional Head of AI audits your stack, identifies opportunities, and delivers a prioritized AI roadmap.',
    icon: <SearchIcon className="w-12 h-12 text-primary group-hover:text-primary-light transition-transform duration-300" data-id="element-266" />,
    number: 2
  }, {
    title: 'Ship & iterate',
    description: 'Rapid POCs, evaluations, and production AI features — shipped alongside your team, with governance baked in.',
    icon: <RocketIcon className="w-12 h-12 text-primary group-hover:text-primary-light transition-transform duration-300" data-id="element-267" />,
    number: 3
  }];
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="ai-process" className="py-20 bg-white relative overflow-hidden" data-id="element-268">
      <div className="absolute top-0 left-0 w-64 h-64 bg-purple-50 rounded-full opacity-60 -ml-32 -mt-32" data-id="element-269"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-50 rounded-full opacity-50 -mr-40 -mb-40" data-id="element-270"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-271">
        <div className="text-center mb-16" data-id="element-272">
          <p className="text-primary font-medium mb-2" data-id="element-273">OUR PROCESS</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-274">
            How It Works
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-275">
            A focused three-step process that gets an experienced AI leader
            working on your business in days, not months.
          </p>
        </div>
        <div className="hidden md:block max-w-5xl mx-auto relative" data-id="element-276">
          <div className="absolute top-1/2 left-[calc(16.67%+32px)] right-[calc(16.67%+32px)] h-0.5 bg-gray-200 -mt-0.5 z-0" data-id="element-277"></div>
          <div className="grid grid-cols-3 gap-8" data-id="element-278">
            {steps.map((step, index) => <div key={index} className="relative" data-id="element-279">
                <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-280">
                  {step.number}
                </div>
                <Card className="text-center group relative z-10" data-id="element-281">
                  <div className="mb-6 flex justify-center" data-id="element-282">{step.icon}</div>
                  <h3 className="text-xl font-bold mb-2 text-black" data-id="element-283">
                    {step.title}
                  </h3>
                  <p className="text-text-secondary" data-id="element-284">{step.description}</p>
                </Card>
              </div>)}
          </div>
        </div>
        <div className="md:hidden space-y-12 max-w-sm mx-auto" data-id="element-285">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-286">
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-287">
                {step.number}
              </div>
              <Card className="text-center group" data-id="element-288">
                <div className="mb-6 flex justify-center" data-id="element-289">{step.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-black" data-id="element-290">
                  {step.title}
                </h3>
                <p className="text-text-secondary" data-id="element-291">{step.description}</p>
              </Card>
              {index < steps.length - 1 && <div className="h-8 w-0.5 bg-gray-200 mx-auto mt-4" data-id="element-292"></div>}
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-293">
          <Button variant="primary" onClick={openCalendly} className="text-lg px-8 py-4" data-id="element-294">
            Speak with an AI Lead
          </Button>
        </div>
      </div>
    </section>;
};